import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "../../config/firebase-config";
import useColection from "../colection";
import { useCallback, useContext, useState } from "react";
import { UserContext } from "../../context";

const useClients = () => {
  const { uploadPhoto, savePhotoUrl, ...others } =
    useColection<Client>("clients");

  const [clientsWithLocation, setClientsWithLocation] = useState<Client[]>([]);
  const uploadLogo = async (userId: string, file: File) => {
    const logoUrl = await uploadPhoto(userId, file);
    savePhotoUrl(userId, { logo: logoUrl });
  };

  const featCleints = useCallback(() => {
    others.get().then((clients) => {
      console.log(clients);
      const clientAuxi = clients.filter(
        (client) => client.address?.geolocation !== undefined
      );
      setClientsWithLocation(clientAuxi);
    });
  }, []);
  return {
    ...others,
    uploadPhoto: uploadLogo,
    featCleints,
    clientsWithLocation,
  };
};

export default useClients;
